const Gradient = () => <div className="absolute bg-gradient-to-b from-transparent to-grey-600 w-full h-[50px] bottom-0 left-0 select-none pointer-events-none"/>

export default Gradient
